import { AnimatePresence, motion } from 'framer-motion';
import type React from 'react';

export interface CollapseAnimationProps {
  open: boolean;
  children?: React.ReactNode;
}

export const CollapseAnimation = ({
  open,
  children,
}: CollapseAnimationProps) => {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial="collapsed"
          animate={open ? 'open' : 'collapsed'}
          exit="collapsed"
          variants={{
            open: { height: 'auto', opacity: 1 },
            collapsed: { height: 0, opacity: 0 },
          }}
          transition={{
            duration: 0.1,
          }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
